'use client';

import Link from 'next/link';

import clsx from 'clsx';
import SVG from 'react-inlinesvg';

import { useGlobal } from '@/lib/global-store';

import { ThreeDee } from '../components/3d';
import { Text } from '../components/text';
import { Margin, Wrapper, getMarginClassNames } from './utils';

export interface Action {
  icon?: { svg: string };
  title: string;
  type: 'link' | 'button';
  description?: string;
  href?: string;
}

export interface ActionBarProps {
  actions: Action[];
  margin?: Margin;
}

export function ActionBar({ actions, margin }: ActionBarProps) {
  const { setOpenBook } = useGlobal();

  return (
    <Wrapper className={clsx('h-max max-w-screen-xl lg:h-0', getMarginClassNames(margin))}>
      <div className="-mt-20 flex flex-col justify-center gap-4 lg:-mt-24 lg:flex-row">
        {actions.map((action, i) => {
          if (action.type === 'link') {
            return (
              <Link className="flex-1" key={action.title + i} href={action.href ?? ''}>
                <Action action={action} />
              </Link>
            );
          } else {
            return (
              <button
                className="flex-1"
                key={action.title + i}
                onClick={() => {
                  setOpenBook(true);
                }}
              >
                <Action action={action} />
              </button>
            );
          }
        })}
      </div>
    </Wrapper>
  );
}

export function Action({ action }: { action: Action }) {
  return (
    <ThreeDee className="group flex items-center gap-4 p-4 pr-6 backdrop-blur-lg transition-colors ease-out hover:border-white/50">
      {action.icon && (
        <SVG src={action.icon.svg} className="group-hover:animate-wobble size-9 shrink-0 stroke-[1.25px]" />
      )}

      <div className="flex flex-col">
        <Text element="h3" elementStyle="h4">
          {action.title}
        </Text>
        {action.description && (
          <Text element="p" className="text-muted-foreground text-sm leading-snug">
            {action.description}
          </Text>
        )}
      </div>
    </ThreeDee>
  );
}
